<template>

  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title class = "heading" v-if="mode == 'BILLING'">CREATE RATE</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'BILLING_CHANGE'">CHANGE RATE</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'COST'">CREATE RATE</md-dialog-title>
      <md-dialog-title class = "heading" v-if="mode == 'COST_CHANGE'">CHANGE RATE</md-dialog-title>

     

      <md-dialog-content >
        <form id = "top" novalidate @submit.prevent="doSaveUser">


        
        <div v-if="mode == 'BILLING' || mode == 'BILLING_CHANGE'" class = "layout">
            <auto-complete-master-data-select  :class="getValidationClass('dataForm.rateType')"
                                                group="GST_RATE_BILLING"
                                                label="RATE TYPE"
                                                :init-value="dataForm.rateType"
                                                :on-item-changed="handleRateTypeChanged"
                                                :disabled="mode == 'BILLING_CHANGE'"
                                                >
            </auto-complete-master-data-select>
        </div>


        <div v-if="mode == 'COST' || mode == 'COST_CHANGE'" class = "layout">
            <auto-complete-master-data-select  :class="getValidationClass('dataForm.rateType')"
                                                group="GST_RATE_COST"
                                                label="RATE TYPE"
                                                :init-value="dataForm.rateType"
                                                :on-item-changed="handleRateTypeChanged"
                                                :disabled="mode == 'COST_CHANGE'"
                                                >
            </auto-complete-master-data-select>
        </div>

        <div class = "layout">
            <md-field>
            <label for="rdesc">Description</label>
            <md-input name="rdesc"
                      id="rdesc"
                      autocomplete="new-password"
                      v-model="dataForm.rdesc"
                      disabled
            />
            </md-field>
        </div>


        <div class = "layout">
            <md-field>
            <label for="unit">Measure Unit</label>
            <md-input name="unit"
                      id="unit"
                      autocomplete="new-password"
                      v-model="dataForm.unit"
                      disabled
            />
            </md-field>
        </div>


        <div class = "layout">
            <md-field>
            <label for="amt">Unit Price</label>
            <md-input name="amt"
                      id="amt"
                      autocomplete="new-password"
                      v-model="dataForm.amt"
            />
            </md-field>
        </div>

                <div class = "layout">
            <md-field>
            <label for="required"> {{dataForm.required == "YES" ? "Required(YES)" : "Optional"}}</label>
            <md-input name="Required"
                      id="required"
                      autocomplete="new-password"
                      :disabled="true"
            />
             <md-checkbox v-model="dataForm.required" 
             value="YES"><span></span>
             </md-checkbox>
          </md-field>

        </div>



        <div class = "alwaysShow">
          <div >
              <callingApiCenter class = "custButtonRight" type="bar" :paths="['/api/w/gst/gstpriceagreementItem/create','/api/w/gst/gstpriceagreementitem/update']"></callingApiCenter>
              <md-dialog-actions >
              <md-button class="md-raised custButton " @click="cancalAction"><span class="icons-center material-icons">cancel</span>Close</md-button>
              <md-button type="submit" class="md-raised custButton "><span class="icons-center material-icons">create</span>Create</md-button>
            </md-dialog-actions>
          </div>
        </div>
        </form>
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
  form {
    min-width: 640px;
    margin: 24px;
    
  }
  

  .alwaysShow {
  position: fixed;
  
  right: 60px;
  top : 30px;
}


    .redButton{

        background-color: #c50000;
        z-index: 4;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
    }


.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}



  .custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}



    .heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 32px;
      font-family: Roboto Slab;
      margin-left: 44px;


}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
    
      font-family: Roboto Slab;
      margin: auto;
  }


  .md-table-row
{
  background: white;
}


.md-table.md-theme-default .md-table-row.md-selected-single
{
background: #726a95;
}



</style>
<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import AutocompleteCcicLocationSelect from "./AutocompleteCcicLocationSelect.vue";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialdataForm = () => ({
    rateType: null,
    rdesc: null,
    unit: null,
    amt: null,
    remark: null,
    agreement: null,
    required: null,
    
  });

  export default {
    components: { AutocompleteCcicLocationSelect ,callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
      action: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialdataForm(),
      items: [],
      selected:null,
      drivers: [],
    }),
    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
      ]),
      
    },

    validations: {
      dataForm: {
          rateType: {},
          rdesc: {},

    
      },
    },

 
    methods: {



      async openDialog(existingUser) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialdataForm();

        this.dataForm.agreement = existingUser.agreement

        if (existingUser && (this.mode == 'BILLING_CHANGE' || this.mode == 'COST_CHANGE')) {
            this.dataForm.rateType = existingUser.rateType;
            this.dataForm.rdesc = existingUser.rdesc;
            this.dataForm.unit = existingUser.unit;
            this.dataForm.amt = existingUser.amt;
            this.dataForm.required = existingUser.required;  
        }
        this.showDialog = true;
      },

      
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },


      handleRateTypeChanged(id, name, unit, req) {
        console.log(`handleStageTypeChanged`, id, name, unit);
    
        this.dataForm.rateType = id;
        this.dataForm.rdesc = name;
        this.dataForm.unit = unit;
        this.dataForm.required = req;
      },


     cancalAction(){
        this.showDialog = false;
        this.$store.commit('clearApiError');
     },

      async doSaveUser() {
        this.$v.dataForm.$touch();
        console.log(JSON.stringify(this.dataForm));
        const req = this.dataForm;
        console.log(req);

        var test =  this.dataForm.amt.match(/^[0-9]*(\.[0-9]{1,3})?$/);
        //var test = amtCheck.test(this.dataForm.amt);
        if (!test) {
           alert("Unit Price is not numeric or more than 3 decimal!");  
           return;
        }

        if (this.mode == 'BILLING' || this.mode == 'COST')
        {
        //await  api.post("/api/w/gst/gstpriceagreementItem/create", req)
        await newAPIPost("/api/w/gst/gstpriceagreementItem/create", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action('Item created!');
          });
        }

        if (this.mode == 'BILLING_CHANGE' || this.mode == 'COST_CHANGE')
        {
         //await  api.post("/api/w/gst/gstpriceagreementitem/update", req)
         await newAPIPost("/api/w/gst/gstpriceagreementitem/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.action('Item Update!');
          });
        }
        
         this.$store.commit('clearApiError');
      },
    },
  };
</script>
